<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">项目经验</span>
      <el-button type="primary" @click="createProject">新增项目经验</el-button>
    </template>

    <div v-loading="loading" class="projects">
      <template v-if="list.length > 0">
        <el-row :gutter="20">
          <template v-for="(item, index) in list">
            <el-col :key="index" class="project-item" :span="12">
              <el-card @click.native="projectDetail(item)">
                <template slot="header">
                  <span class="project-name ellipsis--l1">{{ item.title }}</span>
                  <div class="project-actions">
                    <el-button class="project-edit" type="text" @click.stop="editProject(item)">编辑</el-button>
                    <el-button class="project-delete" type="text" @click.stop="deleteProject(item.id)">删除</el-button>
                  </div>
                </template>
                <div class="cell">
                  <div class="cell-label">项目地点</div>
                  <div class="cell-content ellipsis--l1" :title="item.location">{{ item.location }}</div>
                </div>
                <div class="cell">
                  <div class="cell-label">项目金额</div>
                  <div class="cell-content ellipsis--l1" :title="item.amount">{{ item.amount }}</div>
                </div>
                <div class="cell">
                  <div class="cell-label">项目内容</div>
                  <div class="cell-content ellipsis--l3" :title="item.content">{{ item.content }}</div>
                </div>
              </el-card>
            </el-col>
          </template>
        </el-row>
        <!-- <el-pagination
                background
                layout="prev, pager, next, jumper"
                :current-page="pagination.current"
                :page-size="pagination.size"
                :total="pagination.total"
                @current-change="pageChange"
            ></el-pagination> -->
      </template>
      <empty-layout v-else />
    </div>

    <el-dialog
      :title="dialogTitle"
      top="5vh"
      destroy-on-close
      :visible.sync="showDialog"
      @closed="resetForm"
    >
      <el-form
        ref="form"
        :key="editID"
        label-position="right"
        label-width="auto"
        :disabled="mode === 'detail'"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="项目标题" prop="title">
          <el-input v-model.trim="form.title" placeholder="请输入项目标题" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="项目地点" prop="location">
          <el-input v-model.trim="form.location" placeholder="请输入项目地点" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="项目金额" prop="amount">
          <el-input v-model.trim="form.amount" placeholder="请输入项目金额" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="项目内容" prop="content">
          <el-input v-model.trim="form.content" type="textarea" maxlength="500" show-word-limit placeholder="请输入项目内容" :rows="6" />
        </el-form-item>
        <el-form-item label="项目图片" prop="picture">
          <el-upload
            list-type="picture-card"
            :limit="5"
            :action="uploadAction"
            :file-list="filelist"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-remove="pictureRemove"
            :on-exceed="uploadExceed"
            :class="{ 'hideUploadBtn': form.picture.length >= 5 || mode === 'detail' }"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="saveProject">确定</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import EmptyLayout from '@/components/EmptyLayout'
import { fetchProjects, createProject, updateProject, deleteProject } from '@/api'

export default {

  components: {
    EmptyLayout
  },
  data() {
    return {
      mode: 'add',

      list: [],

      // pagination: {
      //     current: 1,
      //     size: 4,
      //     total: 0,
      // },

      editID: '',
      filelist: [],
      form: {
        title: '',
        location: '',
        amount: '',
        content: '',
        picture: []
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入项目标题',
            trigger: 'blur'
          }
        ],
        location: [
          {
            required: true,
            message: '请输入项目地点',
            trigger: 'blur'
          }
        ],
        amount: [
          {
            required: true,
            message: '请输入项目金额',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '请输入项目内容',
            trigger: 'blur'
          }
        ]
      },

      uploadAction: `${process.env.VUE_APP_API_URL}api/upload/upload`,

      showDialog: false,
      loading: false
    }
  },

  computed: {
    dialogTitle() {
      let title = ''

      switch (this.mode) {
        case 'add':
          title = '新增项目经验'
          break
        case 'edit':
          title = '编辑项目经验'
          break
        case 'detail':
          title = '查看项目经验'
          break
        default:
          title = ''
          break
      }

      return title
    }
  },

  created() {
    this.fetchProjects()
  },

  methods: {
    async fetchProjects() {
      this.loading = true

      try {
        const res = await fetchProjects()

        this.list = res.data
      } catch (error) {
        this.$message.error(error.message)
      }

      this.loading = false
    },

    setInitFormData(project) {
      this.form.title = project.title
      this.form.location = project.location
      this.form.amount = project.amount
      this.form.content = project.content
      this.form.picture = project.picUrl ? project.picUrl.split(';').map(val => ({ url: val })) : []
      this.filelist = [...this.form.picture]
    },

    resetForm() {
      this.$nextTick(() => {
        this.editID = ''
        this.$refs.form.resetFields()
        this.filelist = []
        Object.assign(this.form, this.$options.data().form)
      })
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('文件大小超过 2MB')
      }

      const isImage = new RegExp('image/*').test(file.type)
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }

      return isLt2M && isImage
    },

    uploadSuccess(res, file, filelist) {
      this.form.picture.push({
        url: res.data.url
      })
    },

    pictureRemove(file, filelist) {
      this.form.picture = this.form.picture.filter(val => {
        return val.url !== (file.response ? file.response.data.url : file.url)
      })
      this.filelist = filelist
    },

    uploadExceed(file, filelist) {
      this.$message.error('最多上传5张图片')
    },

    createProject() {
      this.mode = 'add'
      this.showDialog = true
    },

    projectDetail(project) {
      this.mode = 'detail'
      this.setInitFormData(project)
      this.showDialog = true
    },

    editProject(project) {
      this.mode = 'edit'
      this.editID = project.id
      this.setInitFormData(project)
      this.showDialog = true
    },

    saveProject() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中...'
          })

          const params = {
            title: this.form.title,
            location: this.form.location,
            amount: this.form.amount,
            content: this.form.content,
            picUrl: this.form.picture.map(val => val.url).join(';')
          }

          if (this.editID) {
            Object.assign(params, {
              id: this.editID
            })
          }

          try {
            await (this.editID ? updateProject(params) : createProject(params))

            this.$message.success('保存成功！')
            this.showDialog = false

            this.$nextTick(() => {
              this.fetchProjects()
            })
          } catch (error) {
            this.$message.error(error.message)
          }

          loading.close()
        }
      })
    },

    deleteProject(id) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        type: 'warning'
      })
        .then(async() => {
          try {
            await deleteProject({
              id
            })

            this.$message.success('删除成功!')
            this.fetchProjects()
          } catch (error) {
            this.$message.error(error.message)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.projects {
    .project-item {
        font-size: 14px;
        &:nth-child(n + 3) {
            margin-top: 20px;
        }
        /deep/ .el-card__header {
            height: 60px;
        }
        .project-name {
            flex: 1;
            font-weight: bold;
        }
        .project-actions {
            flex-shrink: 0;
            margin: 0 0 0 10px;
            .el-button {
                width: auto;
                height: auto;
                font-size: inherit;
                +.el-button {
                    margin: 0 0 0 30px;
                }
            }
            .project-delete {
                color: #f56c6c;
            }
        }

        .cell {
            display: flex;
            line-height: 20px;
            + .cell {
                margin: 15px 0 0;
            }
            .cell-label {
                flex: 0 0 80px;
                color: #666;
                padding: 0 20px 0 0;
            }
            .cell-content {
                flex: 1;
            }
            .ellipsis--l3 {
              height: 60px;
            }
        }
    }
}

/deep/ .el-dialog {
    border-radius: 6px;
    .el-dialog__footer {
        text-align: center;
        .el-button {
            + .el-button {
                margin: 0 0 0 30px;
            }
        }
    }
    .el-form {
        .el-form-item {
            &:last-child {
                margin: 0;
            }
        }
    }
    .hideUploadBtn {
        .el-upload--picture-card {
            display: none;
        }
    }
}

.el-pagination {
    display: table;
    margin: 40px auto 0;
}
</style>
